import React from 'react'
import { Layout, Menu, } from 'antd';
import { UserOutlined, LaptopOutlined, NotificationOutlined } from '@ant-design/icons';

import {
  Switch,
  Link
} from "react-router-dom";

import Admin from './Home'
import Users from './Users'
import Allproducts from './allProducts'
import NewAllproducts from './newAllProducts'
import NewUpdates from './newUpdates'
import AllUpdates from './allUpdates'

const { SubMenu } = Menu;
const {  Sider } = Layout;

export const routes = [
  {
    path: "/",
    exact: true,
    main: () => <><Admin/></>
  },
  {
    path: "/users",
    main: () => <><Users/></>
  },
  {
    path: "/allProducts",
    main: () => <><Allproducts/></>
  },
  {
    path: "/NewallProducts",
    main: () => <><NewAllproducts/></>
  },
  {
    path: "/NewUpdates",
    main: () => <><NewUpdates/></>
  },
  {
    path: "/AllUpdates",
    main: () => <><AllUpdates/></>
  }
  
];

export default function SideBar() {
    
    return(
        <Sider className="site-layout-background" width={200} style={{height: '93vh'}}
        
         breakpoint="lg"
      collapsedWidth="0"
      onBreakpoint={broken => {
        console.log(broken);
      }}
      onCollapse={(collapsed, type) => {
        console.log(collapsed, type);
      }}
      >

<div>
                  
          <Switch>
           

            <Menu
                mode="inline"
                defaultSelectedKeys={['1']}
                defaultOpenKeys={['sub1']}
                style={{ height: '100vh' }}
              >
                
                <Menu.Item key="1"> <Link to="/">Home</Link></Menu.Item>
                
                <SubMenu
                  key="sub1"
                  title={
                    <span>
                      <UserOutlined />
                      Users
                    </span>
                  }
                >
                  <Menu.Item key="101"> <Link to="/users">All Users</Link></Menu.Item>
                </SubMenu>

                <SubMenu
                  key="sub2"
                  title={
                    <span>
                      <LaptopOutlined />
                      Grants
                    </span>
                  }
                >
                  <Menu.Item key="104"><Link to="/AllUpdates">All Grants</Link></Menu.Item>
                  <Menu.Item key="103"><Link to="/NewUpdates">New Grant</Link></Menu.Item>                  
                </SubMenu>

                <SubMenu
                  key="sub3"
                  title={
                    <span>
                      <NotificationOutlined />
                      All Products
                    </span>
                  }
                >
                  <Menu.Item key="105"><Link to="/allProducts">All Entries</Link></Menu.Item>
                  <Menu.Item key="106"><Link to="/NewallProducts">Add New</Link></Menu.Item>
                </SubMenu>
              
     

              </Menu>

          </Switch>


         
        </div>

</Sider>
           
    )
}